export enum PriceSuffix {
  PerYear = "PerYear",
  PerKg = "PerKg",
  PerContract = "PerContract",
  ForBusiness = "ForBusiness",
  ForConsumer = "ForConsumer",
}

export interface Price {
  id: number;
  year: number;
  name: string;
  ecomodClassId: number;
  supClassId: number | null;
  priceInfo: {
    amount: number;
    suffix: PriceSuffix;
  }[];
}
